module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-mitsu.1c6d48c4.jpg";